module.exports = __webpack_public_path__ + "static/img/360.7cff079.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/360.jpg
// module id = eqmG
// module chunks = 1